import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.project.BillAddress')
export class CustomerRef extends AbstractModel {

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'value')
    value?: string;
}
